import { render, staticRenderFns } from "./techSupportBlock.vue?vue&type=template&id=61826ede&scoped=true&"
import script from "./techSupportBlock.vue?vue&type=script&lang=js&"
export * from "./techSupportBlock.vue?vue&type=script&lang=js&"
import style0 from "./techSupportBlock.vue?vue&type=style&index=0&id=61826ede&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61826ede",
  null
  
)

export default component.exports